export default "assets/images/9a243e0cb0fc43e2a016d5d3aaa330d5.png";